import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28 flex flex-col items-center justify-center text-center">
        <p className="font-black text-7xl md:text-9xl text-primary-500/20 select-none">404</p>
        <span className="mt-2 w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-3xl">
          <i className="ri-emotion-sad-line" />
        </span>
        <h1 className="mt-5 text-2xl md:text-3xl font-black text-foreground-950">页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-500 max-w-md">
          你访问的页面可能已被移除或链接有误。
        </p>
        <p className="mt-1 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>
        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line" />
            去搜索资讯
          </Link>
        </div>
      </div>
    </Layout>
  );
}